class Translations {
  constructor(messages, defaultLocale, locale, merge = true) {
    this.messages = messages;
    this.defaultLocale = defaultLocale;
    this.locale = locale;

    if (merge) {
      this.messages = this.mergedMessages;
    }
  }

  get defaultMessages() {
    return this.messages[this.defaultLocale];
  }

  get localeMessages() {
    return this.messages[this.locale];
  }

  get mergedMessages() {
    const merged = Object.assign({}, this.defaultMessages, this.localeMessages);
    return this.assignDefaultToEmptyValues(merged, this.defaultMessages);
  }

  assignDefaultToEmptyValues(target, defaults) {
    Object.keys(target).forEach(key => {
      if (!target[key] && defaults[key]) {
        target[key] = defaults[key];
      }
    });

    return target;
  }
}

export default Translations;



// WEBPACK FOOTER //
// ./app/javascript/common/translations.js